import { request } from '@services'

export const state = {
  loading: false,
  data: null,
  errors: null,
}

export const getters = {
  getAgentList(state) {
    return state.data
  },
}

export const mutations = {
  SET_AGENT_LIST_REQUESTED(state) {
    state.loading = true
  },
  SET_AGENT_LIST_RECEIVED(state, newData) {
    state.loading = false
    state.data = newData
    state.errors = null
  },
  SET_AGENT_LIST_RECEIVED_FAILED(state, error) {
    state.loading = false
    state.errors = error
  },
  RESET_AGENT_LIST(state) {
    state.loading = false
    state.data = null
    state.errors = null
  },
}

export const actions = {
  async fetchingAgentList({ commit }, params) {
    commit('SET_AGENT_LIST_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/agent/list/',
        payload: { ...params },
      })
      commit('SET_AGENT_LIST_RECEIVED', response)
      return response
    } catch (error) {
      commit('SET_AGENT_LIST_RECEIVED', error)
    }
  },
  resetAgentList({ commit }) {
    commit('RESET_AGENT_LIST')
  },
  async deleteAgentById({ commit }, params) {
    try {
      const response = await request({
        endpoint: '/cms/agent/delete/',
        payload: { ...params },
      })
      return response
    } catch (error) {
      return error
    }
  },
}
